import React from "react";
import PropTypes from "prop-types";
import { component_tool } from '@/tool'
import { Responsive, WidthProvider } from "react-grid-layout";
import './index.less'
const ResponsiveReactGridLayout = WidthProvider(Responsive);
const { WizComponent } = component_tool;

export default class GridLayouts extends WizComponent {
  componentName = 'GridLayouts'
  
  constructor(props) {
    super(props);

    const originalLayout = getFromLS(props.storeKey);
    // console.log('generateLayout()',generateLayout())
    this.state = {
      currentBreakpoint: "lg",
      // mounted: false,
      layouts: { lg: props.initialLayout }
    };

    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    // this.onLayoutChange = this.onLayoutChange.bind(this);
  }

  componentDidMount() {
    // this.setState({ mounted: true })
  }

  onBreakpointChange(breakpoint) {
    this.setState({
      currentBreakpoint: breakpoint
    });
  }

  // onLayoutChange(layout, layouts) {
  //   const { storeKey } = this.props
  //   if(storeKey){
  //     saveToLS(storeKey,layout)
  //     this.setState({ layouts: {lg: layout} });
  //   }
  // }
  
  render() {
    const { layouts, mounted } = this.state
    const gridLayoutProps = {
      layouts,
      onBreakpointChange: this.onBreakpointChange,
      // onLayoutChange: this.onLayoutChange,
      measureBeforeMount: false,
      useCSSTransforms: true,
      ...this.props,
    }
    return (
      <ResponsiveReactGridLayout { ...gridLayoutProps } >
        {this.props.children}
      </ResponsiveReactGridLayout>
    );
  }
}

GridLayouts.propTypes = {
  initialLayout: PropTypes.array.isRequired,
};

GridLayouts.defaultProps = {
  className: "layout",
  rowHeight: 150,
  autoSize: true,
  compactType: "horizontal", //horizontal | vertical
  onLayoutChange: function() {},
  cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  isResizable: false,
  isDroppable: true,
  initialLayout: []
};

function getFromLS(key) {
  let ls = {};
  if (global.localStorage) {
    try {
      ls = JSON.parse(global.localStorage.getItem(key)) || {};
    } catch (e) {
      /*Ignore*/
    }
  }
  return ls[key];
}

function saveToLS(key, value) {
  if (global.localStorage) {
    global.localStorage.setItem(
      [key],
      JSON.stringify({
        [key]: value
      })  
    );
  }
}